import React, { createContext, useContext, useState, useCallback } from 'react';
import { getOrganizationById } from '../services/organizationService';

const OrganizationContext = createContext();

export const OrganizationProvider = ({ children }) => {
    const [organizationData, setOrganizationData] = useState(null);
    const [organizationUsers, setOrganizationUsers] = useState(null);
    const [orgId, setOrgId] = useState(null);
    const [userRole, setUserRole] = useState(null); // Add user's role in organization

    const fetchOrganizationData = useCallback(async (organizationId) => {
        try {
            const response = await getOrganizationById(organizationId);
            const data = response.data;
            setOrganizationData(data.organization);
            setOrganizationUsers(data.users);
            
            // Store user's role in the organization
            if (data.organization?.userRole) {
                setUserRole(data.organization.userRole);
            }
            
            // Store org_id if it exists in the response
            if (data.organization?.id) {
                setOrgId(data.organization.id);
            }
        } catch (error) {
            // Error fetching organization data
            setOrganizationData(null);
            setOrganizationUsers(null);
            setOrgId(null);
            setUserRole(null);
        }
    }, []);

    return (
        <OrganizationContext.Provider value={{ 
            organizationData, 
            fetchOrganizationData, 
            organizationUsers,
            orgId,
            userRole
        }}>
            {children}
        </OrganizationContext.Provider>
    );
};

export const useOrganization = () => {
    return useContext(OrganizationContext);
};

// Following the same pattern as ProviderCompanyContext
// API call expects: ${api}/organization/${organizationId}
// Expected response format: 
// {
//   data: {
//     organization: { /* organization object */ },
//     users: { /* organization users/members */ }
//   }
// }
